/*eslint-disable */

import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import Filter from '../Filter';
import { useNavigate } from 'react-router-dom';
import GlobalContext from 'contexts';

import globalTranslating from '../../translate.json';
import ClientTranslate from './translate.json';
import ExcelDownload from 'components/ExcelDownload';
// import '../style.scss';

const AnalysisGeneticTests = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...ClientTranslate };
  const [filteredclients, setFilteredclients] = useState([]);
  const [rssList, setRssList] = useState([]);
  const { data, loading } = useFetchData(
    'client-product/dashboard/geneticAnalysisGenotips'
  );

  useEffect(() => {
    if (data?.data?.length) setFilteredclients(data.data);
    if (data?.rsList?.length) setRssList(data?.rsList);
  }, [data]);

  const onFilter = (filteredData) => {
    setFilteredclients(filteredData);
  };

  const onResetFilters = () => {
    setFilteredclients(clientsData);
  };

  const { showFilters, toggle } = useSort();

  const actionsclientsList = [
    {
      icon: SortIcon,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredclients(clientsData);
        toggle(!showFilters);
      }
    }
  ];

  const tableHeaders = [
    translating.clientId,
    translating.fullName,
    translating.barcode,
    translating.ssn
    // translating.createdDate
  ];

  rssList?.forEach((element) => {
    tableHeaders.push(element.RsNo);
  });

  const [columns, setColumns] = useState([
    { value: 'id' },
    { value: 'clientFullName', sort: true, bold: true },
    { value: 'barcode' },
    { value: 'ssn' }
    // { value: 'createdAt', format: 'date' }
  ]);

  useEffect(() => {
    const newColumns = [...columns];
    rssList?.forEach((element) => {
      newColumns.push({ value: element.RsNo });
    });
    setColumns(newColumns);
  }, [rssList]);

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.analysisGeneticTests}
        actions={actionsclientsList}
      ></ListHeader>
      {/* {showFilters && productsList && (
        <Filter
          fields={sortFields}
          data={clientsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )} */}
      <div className="customers-list-wrapper-table">
        {loading && <div>Loading</div>}
        {filteredclients?.length ? (
          <ExcelDownload
            data={filteredclients}
            filename={'ניתוח תוצאות גנטיות.csv'}
          ></ExcelDownload>
        ) : null}
        {filteredclients && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredclients}
            pagination={true}
          ></TablePagination>
        )}
      </div>
    </div>
  );
};

export default AnalysisGeneticTests;
